import { format } from 'date-fns'

import { Button } from '#app/components/ui/button'
import { Calendar } from '#app/components/ui/calendar'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '#app/components/ui/popover'
import { cn } from '#app/utils/misc.tsx'
import { Icon } from './icon'

export function DatePicker({
	label = 'Elige una fecha',
	date,
	onDateChange,
}: {
	label?: string
	date?: Date
	onDateChange: (date: Date) => void
}) {
	return (
		<Popover>
			<PopoverTrigger asChild>
				<Button
					variant={'outline'}
					className={cn(
						'w-full pl-3 text-left font-normal',
						!date && 'text-muted-foreground',
					)}
				>
					{date ? format(date, 'dd/MM/yy') : <span>{label}</span>}
					<Icon name="calendar" className="ml-auto h-4 w-4 opacity-50" />
				</Button>
			</PopoverTrigger>
			<PopoverContent className="w-auto p-0" align="start">
				<Calendar
					mode="single"
					selected={date}
					onSelect={selectedDate => selectedDate && onDateChange(selectedDate)}
					disabled={date => date > new Date() || date < new Date('1900-01-01')}
					initialFocus
				/>
			</PopoverContent>
		</Popover>
	)
}
